import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Input, InputLabel, MenuItem, Select } from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import { USER_STATUS, USER_STATUS_LABELS } from 'utils/constants/kypStatuses'
import { styles } from './styles'
import { INTERNAL_USER_ROLE_LABELS, INTERNAL_USER_ROLE_VALUES } from "../../../utils/constants/userRoles"

const initialValues = {
  email: '',
  role: INTERNAL_USER_ROLE_VALUES.ALL,
  status: USER_STATUS.ALL,
}

const UserSearchBar = ({ setSearchParams }) => {
  const classes = styles()
  const [formState, setFormState] = useState(initialValues)

  const handleSubmitSearch = () => {
    const queryParams = {
      status: formState.status === USER_STATUS.ALL ? null : formState.status,
      role: formState.role === INTERNAL_USER_ROLE_VALUES.ALL ? null : formState.role,
      email: formState.email || null,
    }

    setSearchParams(queryParams)
  }

  const handleUpdateFormState = (event) => {
    const { name, value } = event.target

    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleKeyPress = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSubmitSearch()
    }
  }

  useEffect(() => {
    handleSubmitSearch()
  }, [formState.role, formState.status])

  useEffect(() => {
    if (formState.email === '') {
      handleSubmitSearch()
    }
  }, [formState.email])
  
  return (
    <div className={classes.root}>
      <div className={classes.leftWrapper}>
        <Input
          type="search"
          name="email"
          placeholder="Email"
          value={formState.email}
          onChange={handleUpdateFormState}
          onKeyUp={handleKeyPress}
        />
        <Button onClick={handleSubmitSearch}>
          <SearchOutlined />
        </Button>
      </div>
      <div className={classes.rightWrapper}>
        <div className={classes.filterStatus}>
          <InputLabel id="status">Status:</InputLabel>
          <Select
            labelId="status"
            id="status"
            name="status"
            value={formState.status}
            onChange={handleUpdateFormState}
            className={classes.select}
            variant="standard"
          >
            {Object.keys(USER_STATUS).map((key) => (
              <MenuItem
                key={USER_STATUS[key]}
                style={{ fontSize: '1.25rem' }}
                value={USER_STATUS[key]}
              >
                {USER_STATUS_LABELS[key]}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className={classes.filterStatus}>
          <InputLabel id="role">Cargo:</InputLabel>
          <Select
            labelId="role"
            id="role"
            name="role"
            value={formState.role}
            onChange={handleUpdateFormState}
            className={classes.select}
            variant="standard"
          >
            {Object.keys(INTERNAL_USER_ROLE_VALUES).map((key) => (
              <MenuItem
                key={INTERNAL_USER_ROLE_VALUES[key]}
                style={{ fontSize: '1.25rem' }}
                value={INTERNAL_USER_ROLE_VALUES[key]}
              >
                {INTERNAL_USER_ROLE_LABELS[key]}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </div>
  )
}

UserSearchBar.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
}

export default UserSearchBar
